import { createSelector, createFeatureSelector, combineReducers } from '@ngrx/store';

import * as fromLayout from './reducers';

export interface AppState{
    reducer:{
        layout: fromLayout.IState
    }
}

export const reducers = {
    layout: fromLayout.reducer
}

const devreducer:Function = combineReducers(reducers);

export function metaReducer(state: any, action: any) { 
    return devreducer(state, action); 
}

export const getLayoutState = (state: AppState) => state.reducer.layout;


// WEBPACK FOOTER //
// C:/Users/Quentin/projets/kontractor/src/app/common/appstore/index.ts